export default "__VITE_ASSET__C72$FeN0__"